import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full bg-bg-softer py-14 px-4 md:px-8" data-id="element-91">
      <div className="max-w-xl mx-auto" data-id="element-92">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white border-2 border-secondary/30 rounded-2xl p-8 text-center" data-id="element-93">
          <div className="bg-bg-mint w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-94">
            <ShieldCheckIcon className="w-8 h-8 text-accent" data-id="element-95" />
          </div>

          <h2 className="text-xl md:text-2xl font-serif text-text-dark mb-4" data-id="element-96">
            🔒 Probalo sin riesgo — 7 días de garantía total
          </h2>

          <p className="text-primary-mid mb-4" data-id="element-97">
            Tenés 7 días completos para probarlo.
          </p>

          <p className="text-primary-mid mb-4" data-id="element-98">
            Si no sentís cambios, claridad o mejoras…
          </p>

          <p className="text-accent font-semibold text-lg mb-4" data-id="element-99">
            👉 te devolvemos el 100% del dinero
          </p>

          <p className="text-primary-mid/70 text-sm" data-id="element-100">
            Sin preguntas. Sin trámites.
            <br data-id="element-101" />
            <span className="font-medium text-text-dark" data-id="element-102">
              El riesgo es mío, no tuyo.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}